import { render } from "./App.vue?vue&type=template&id=2810eff2&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2810eff2&lang=scss"

import exportComponent from "D:\\Users\\asato\\Documents\\GitHub\\suite_totalling_web\\totalling_web\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__